import {
  useWSModal,
  WSActions,
  WSAlert,
  WSElement
} from "@wingspanhq/fe-component-library";
import { RequirementDefinition } from "@wingspanhq/wingspan-api-sdk";
import React from "react";

import { DefaultActionDetails } from "../components/DefaultActionDetails";

export interface ArchiveNotAllowedModalProps {
  requirementDefinition: RequirementDefinition;
  onClose: () => void;
  engagementLength: number;
}

export const ArchiveNotAllowedModal: React.FC<ArchiveNotAllowedModalProps> = ({
  requirementDefinition,
  engagementLength,
  onClose
}) => {
  return (
    <>
      <DefaultActionDetails
        engagementLength={engagementLength}
        requirementDefinition={requirementDefinition}
      />

      <WSAlert
        icon="alert"
        my="2XL"
        size="M"
        theme="warning"
        title="Requirement cannot be archived when:"
      >
        <WSElement as="ul" ml="L">
          <li>Associated with active engagements.</li>
          <li>Actively assigned to contractors.</li>
        </WSElement>
      </WSAlert>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Done",
            onClick: onClose,
            kind: "Secondary"
          }
        ]}
      />
    </>
  );
};

export const useArchiveNotAllowedModal = () => {
  return useWSModal(ArchiveNotAllowedModal, {
    title: "Archive requirement",
    size: "M"
  });
};
